module.exports = __webpack_public_path__ + "images/cqsscc.2386.png";